import { REQUEST, RECEIVE, RESET } from './types';
import reducerFactory, { selectorFactory } from '../Table/reducerFactory';

export default reducerFactory(REQUEST, RECEIVE, RESET);
export const getTable = selectorFactory(['rollouts']);
